export const MARGIN_POLL_INTERVAL_MS = 1_000;
export const BACKGROUND_MARGIN_POLL_INTERVAL_MS = 30_000;

export interface MarginPollingOptions {
    enabled?: boolean;
    refetchInterval?: number | false;
}

export const resolveMarginPollInterval = (options?: MarginPollingOptions): number | false =>
    options?.refetchInterval ?? MARGIN_POLL_INTERVAL_MS;
